import React, { Component } from 'react';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// React Final Form
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';


// Material UI Imports
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

// Material Icons Imports
import IconContentSend from '@material-ui/icons/Send';
import IconContentRemB from '@material-ui/icons/RemoveCircle';
import IconContentReset from '@material-ui/icons/DeleteSweep';

// Components Imports
import FieldCreator from './innerComponents/FieldCreator';
import CustomLoader from './innerComponents/CustomLoader';

// Assets imports
import '../styles/NewProject.css';

const buttonStyle = {
  marginRight: 12,
};

const cardStyles = {
  marginTop: 10,
  marginBottom: 20,
  boxShadow: "none",
  supervisors: {
    marginTop: 10,
    marginBottom: 20,
  }
};

const paperStyle = {
  // General styles for paper
  width: "60%",
  margin: "0 auto",
  height: "auto",
};

const fieldStyle = {
  minHeight: "72px",
  width: "100%",
};

class UpdateCertification extends Component {
  state = {
    description: '',
    url: '',
    dataSource: [],
    refetched: false
  }

  _createCertification = async values => {
    const name = values.name
    const certificationId = this.props.match.params.id
    await this.props.updateMutation({
      variables: {
        certificationId,
        name
      }
    }).then(({ data }) => {
      alert("Certification '" + data.updateCertification.name + "' has been updated successfully.", data)
      this.setState({refetched:false})
      this.props.history.push({
        pathname:"/training/list",
        state: {refetch: true, tab: 2}
      });
    }).catch((error) => {
      var error_text = "";
      error.graphQLErrors.map((item) => (error_text = error_text + "- " + item.message + "\n"))
      alert(error_text)
      console.log('there was an error sending the mutation', error);
    });
  }

  componentDidMount(){
    this.props.certification_query.refetch()
    .then(this.setState({
      refetched: true
    }))
  }

  render() {
    const TextFieldAdapter = ({ input, meta, ...rest }) => (
      <TextField
        {...input}
        {...rest}
        style={fieldStyle}
        onChange={(event) => input.onChange(event.target.value)}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    // Check if the query response is being loaded
    if (this.props.certification_query && this.props.certification_query.loading) {
      return <CustomLoader label={'Loading Certification'}/>
    }

    // Check if there were errrors
    if (this.props.certification_query && this.props.certification_query.error) {
      return <div> Certification Could not be loaded </div>
    }

    // Get the data to render it
    const name_to_be_update = this.props.certification_query.certification.name;

    // TODO this has to be moved to another place
    let update_data_config_for_forms = [
      { input: { "component": TextFieldAdapter, "name": "name", "label": "Name" } }
    ]

    const updateCertificationFormFields = update_data_config_for_forms.map((field, id) =>
      <FieldCreator values={field.input} fill_values={field.fill_values} key={id} />
    );

    return (
      <Paper style={paperStyle} elevation={1} >
        <div>
          <Form
            onSubmit={this._createCertification}
            mutators={{
              ...arrayMutators
            }}
            initialValues={{
              name: name_to_be_update
            }}
            render={({ handleSubmit, mutators: { push, pop }, reset, submitting, pristine, values }) => (

              <form onSubmit={handleSubmit}>
                <div className="NewProject-header">
                  <div className="NewProject-title">
                    <span>Update Certification</span>
                  </div>
                  <div className="NewProject-actions">
                    <Button
                      color="primary"
                      onClick={this.props.history.goBack}
                    ><IconContentRemB style={{marginRight:8}}/> Cancel</Button>
                  </div>

                </div>
                <div className="NewProject-content">
                  <div style={cardStyles}>
                      Basic Information
                      <div>
                        {updateCertificationFormFields}
                      </div>
                  </div>

                </div>
                <div className="NewProject-detailFooter">
                  <div className="buttons">
                    <Button variant="contained"
                      type="submit"
                      color="primary"
                      style={buttonStyle}
                      disabled={submitting || pristine}
                    ><IconContentSend style={{marginRight:8}}/> Submit</Button>
                    <Button variant="contained"
                    type="button"
                      color="secondary"
                      style={buttonStyle}
                      onClick={reset}
                      disabled={submitting || pristine}
                    ><IconContentReset style={{marginRight:8}}/> Reset</Button>
                  </div>
                </div>
              </form>

            )}
          />
        </div>
      </Paper>

    );
  }
}
const updateCertification = gql`
  mutation updateCertification($certificationId: ID!, $name: String) {
    updateCertification(certificationId: $certificationId, input : {name: $name} ) {
      id
      name
    }
  }
`;

const CERTIFICATIONS_QUERY = gql`
  query certification_query($id: ID!){
    certification(id: $id) {
      name
    }
  }
`;


export default compose(
  graphql(CERTIFICATIONS_QUERY, {
    name: 'certification_query',
    options: (props) => ({ variables: { id: props.match.params.id } })
  }),
  graphql(updateCertification, { name: 'updateMutation', options: {
    refetchQueries: ["all_certifications_query"]
  } })
)(UpdateCertification);


// WEBPACK FOOTER //
// src/components/UpdateCertification.js